import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { ReasonsService } from 'app/core/service/reasons.service'
import { ReasonsAction } from '../constants/reasons.constants'
import {
    GetReasons,
    GetReasonsSuccess,
    GetReasonsError,
    GetReasonById,
    GetReasonByIdSuccess,
    GetReasonByIdError,
    PostReason,
    PutReasonSuccess,
    PostReasonError,
    PutReason,
    PostReasonSuccess,
    PutReasonError,
    DeleteReason,
    DeleteReasonSuccess,
    DeleteReasonError,
} from '../actions/reasons.actions'

@Injectable()
export class ReasonsEffects {
  getReasons$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetReasons>(ReasonsAction.GetReasons),
      switchMap(() =>
        this.reasonsService.getReasons().pipe(
          mergeMap((reasons: any) => {
            return of(new GetReasonsSuccess(reasons));
          }),
          catchError((error) => {
            return of(new GetReasonsError());
          }),
        )
      ),
    ),
  );

  getReasonById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetReasonById>(ReasonsAction.GetReasonById),
      switchMap((action) =>
        this.reasonsService.getReasonById(action.id).pipe(
          mergeMap((reason: any) => {
            return of(new GetReasonByIdSuccess(reason));
          }),
          catchError((error) => {
            return of(new GetReasonByIdError());
          }),
        )
      ),
    ),
  );

  postReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PostReason>(ReasonsAction.PostReason),
      switchMap((action) =>
        this.reasonsService.postReason(action.data).pipe(
          mergeMap((reason: any) => {
            return of(new PostReasonSuccess(reason));
          }),
          catchError((error) => {
            return of(new PostReasonError());
          }),
        )
      ),
    ),
  );

  putReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PutReason>(ReasonsAction.PutReason),
      switchMap((action) =>
        this.reasonsService.putReason(action.data).pipe(
          mergeMap((reason: any) => {
            return of(new PutReasonSuccess(reason));
          }),
          catchError((error) => {
            return of(new PutReasonError());
          }),
        )
      ),
    ),
  );

  deleteReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteReason>(ReasonsAction.DeleteReason),
      switchMap((action) =>
        this.reasonsService.deleteReason(action.id).pipe(
          mergeMap(() => {
            return of(new DeleteReasonSuccess(action.id));
          }),
          catchError((error) => {
            return of(new DeleteReasonError());
          }),
        )
      ),
    ),
  );

  constructor(
    private reasonsService: ReasonsService,
    private actions$: Actions,
  ) {}
}